/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  createCoachCheckoutSession,
  getCoachOfferDetails,
} from "../redux/Slices/leadOfferSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Common/Loader";
import { useParams } from "react-router-dom";

const CoachConfirmationPage = () => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const { leadOfferDetailsId } = useParams();

  useEffect(() => {
    if (leadOfferDetailsId)
      dispatch(getCoachOfferDetails({ leadOfferDetailsId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, leadOfferDetailsId]);

  const {
    loading,
    coachOfferData,
    coachCheckoutSession,
    errorCoachOfferDetails,
  } = useSelector((state) => state.leadOffer);

  const callCoachCreateCheckoutSessionAPI = () => {
    setIsChecked(false);
    if (coachOfferData?.LeadID) {
      const leadOfferDetailsId = coachOfferData?.LeadID;
      dispatch(createCoachCheckoutSession({ leadOfferDetailsId }));
    }
  };

  useEffect(() => {
    if (coachCheckoutSession) {
      localStorage.setItem("isAdminCoach", true);
      localStorage.setItem("isCoach", false);
      localStorage.setItem("checkoutSessionId", coachCheckoutSession.id);
      localStorage.setItem("payment_LeadOfferDetailsId", leadOfferDetailsId);
      // window.open(coachCheckoutSession?.url, "_blank");
      window.location.href = coachCheckoutSession?.url;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coachCheckoutSession]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : errorCoachOfferDetails ? (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white-100">
          <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-lg text-center">
            <h2 className="text-2xl font-semibold mb-2">
              {errorCoachOfferDetails}
            </h2>
            <p className="text-sm">Please try again.</p>
          </div>
        </div>
      ) : (
        <div className=" formContainer d-flex justify-content-center align-items-center bg-light">
          <div
            className="clientDetailsInfoTabContainer p-5 margin-auto "
            style={{ width: "500px" }}
          >
            <h3 className="fw-bold">Dear User,</h3>

            <p className="fs-5 fst-normal">
              We have agreed to you’ll be all set to start coaching with us.
            </p>

            <p className="fs-5 fst-normal">
              The subscription will start shortly after you have pressed <br />{" "}
              the button below. <br />
            </p>

            <p className="fs-5 fst-normal">
              The Monthly Amount :{" "}
              <b>
                {coachOfferData?.Currency}{" "}
                {coachOfferData?.MonthlySubcriptionAmount}
              </b>
              .
            </p>

            <p className="fs-5 fst-normal">
              Subsequently, you will be charged{" "}
              <b>
                {coachOfferData?.Currency}{" "}
                {coachOfferData?.MonthlySubcriptionAmount} every month
              </b>
              .
            </p>

            <p className="fs-5 fst-normal">
              The Percentage : <b>{coachOfferData?.AdminPercentage}%</b>.
            </p>

            <p className="fs-5 fst-normal">
              The OnBoarding Fee : <b>{coachOfferData?.OnboardingFee}</b>.
            </p>

            <p className="fs-5 fst-normal">
              To cancel your subscription, please email us or contact <br />
              us via the chat function in the app.
            </p>

            <p className="fs-5 fst-normal">
              Your payment method information will be transferred <br />{" "}
              securely using SSL encryption. The data will be stored at <br />{" "}
              the third party payment provider Stripe. <br />
            </p>

            <h5 className="text-center mt-3 fw-bold">
              I look forward to getting started!
            </h5>

            {/* Checkbox Confirmation */}
            <div className="form-check mt-3">
              <input
                className="form-check-input fs-4"
                type="checkbox"
                id="confirmationCheckbox"
                onChange={(e) => setIsChecked(e.target.checked)}
                aria-label="Confirm acceptance"
              />
              <label htmlFor="confirmationCheckbox" className="fst-normal ms-1">
                <p>
                  By clicking 'Get Started', you confirm the following:
                  <br />
                  1) You accept our{" "}
                  <a href="#" className="text-color text-decoration-none">
                    Coaching Information
                  </a>{" "}
                  and{" "}
                  <a href="#" className="text-decoration-none text-color">
                    Terms & Conditions
                  </a>
                  .
                  <br />
                  2) You are over 18 years of age or have parental consent.
                </p>
              </label>
            </div>

            {/* Submit Button */}
            <button
              className="btn mt-3 w-25"
              style={{
                backgroundColor: isChecked ? "#1769bb" : "grey",
                color: "white",
                borderRadius: "10px",
                padding: "10px",
              }}
              onClick={() => callCoachCreateCheckoutSessionAPI()}
              disabled={!isChecked}
            >
              Get Started!
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CoachConfirmationPage;
